import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { SelfDeclarationService, SelfDeclarationUpdateDto } from 'src/api/v2';
import {
  SIVA_CONTRACTS_DETAIL_KEY,
  SIVA_CONTRACTS_KEY,
  SIVA_REPORT_DECLARATION,
} from 'src/constants/hook-keys';

export const useSelfDeclaration = (year: number, contractNumericId?: number) => {
  const [selfDeclarationService] = useState(() => new SelfDeclarationService());
  const queryClient = useQueryClient();

  const { data } = useQuery({
    queryFn: () => selfDeclarationService.getList(year),
    queryKey: [SIVA_REPORT_DECLARATION, year],
  });

  const upsertSelfDeclaration = useMutation({
    mutationFn: (dto: SelfDeclarationUpdateDto) => {
      if (!dto) return Promise.reject('An object was not provided properly.');
      return selfDeclarationService.upsert(dto);
    },
    onSuccess: () => {
      queryClient.invalidateQueries([SIVA_REPORT_DECLARATION, year]);
      queryClient.invalidateQueries([SIVA_CONTRACTS_KEY]);
      if (contractNumericId) {
        queryClient.invalidateQueries([SIVA_CONTRACTS_DETAIL_KEY, contractNumericId]);
      }
    },
  });

  return { data, upsertSelfDeclaration };
};
